"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateWorkflowDialog = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const useCreateWorkflow_1 = require("../hooks/useCreateWorkflow");
const useFindWorkflows_1 = require("../hooks/useFindWorkflows");
const TaskTypePicker_1 = require("../task-types/pickers/TaskTypePicker");
const StyledAlert = (0, styled_components_1.default)(lab_1.Alert) `
  .MuiAlertTitle-root {
    font-size: 15px;
    font-weight: 600;
  }
  ul {
    margin-top: 8px;
    margin-bottom: 8px;
    padding-left: 24px;
  }
`;
const CreateWorkflowDialog = props => {
    const { open, onCancel, onCreated } = props;
    const onCreatedRef = (0, react_1.useRef)(onCreated);
    const [error, setError] = (0, react_1.useState)();
    const [existingWorkflow, setExistingWorkflow] = (0, react_1.useState)();
    const [form, setForm] = (0, react_1.useState)({});
    // find conflicting workflows for specific task type
    const { workflowList, error: findError, findWorkflows } = (0, useFindWorkflows_1.useFindWorkflows)();
    const { createdWorkflow, isLoading, error: createError, createWorkflow } = (0, useCreateWorkflow_1.useCreateWorkflow)();
    const hasExisting = !!existingWorkflow && !form.replaceTaskType;
    (0, react_1.useEffect)(() => {
        onCreatedRef.current = onCreated;
    }, [onCreated]);
    (0, react_1.useEffect)(() => {
        if (!open) {
            setForm({});
            setError(undefined);
            setExistingWorkflow(undefined);
        }
    }, [open]);
    (0, react_1.useEffect)(() => {
        form.taskTypeId
            ? findWorkflows({ taskTypeId: form.taskTypeId, includeDeleted: true })
            : setExistingWorkflow(undefined);
    }, [form.taskTypeId, findWorkflows]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (createdWorkflow) {
            (_a = onCreatedRef.current) === null || _a === void 0 ? void 0 : _a.call(onCreatedRef, createdWorkflow);
        }
    }, [createdWorkflow]);
    (0, react_1.useEffect)(() => {
        setError(createError);
    }, [createError]);
    (0, react_1.useEffect)(() => {
        setExistingWorkflow(workflowList === null || workflowList === void 0 ? void 0 : workflowList.data[0]);
    }, [workflowList]);
    (0, react_1.useEffect)(() => {
        findError && setExistingWorkflow(undefined);
    }, [findError]);
    (0, react_1.useEffect)(() => {
        setForm(form => (Object.assign(Object.assign({}, form), { replaceTaskType: false })));
    }, [existingWorkflow]);
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, maxWidth: 'xs', open: open, onClose: onCancel },
        react_1.default.createElement(core_1.DialogTitle, null, "Create Workflow"),
        react_1.default.createElement("form", null,
            react_1.default.createElement(core_1.DialogContent, null,
                react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
                    react_1.default.createElement(core_1.TextField, { autoFocus: true, fullWidth: true, size: 'small', variant: 'outlined', label: 'Workflow Name', value: form.name || '', onChange: event => {
                            setForm(form => (Object.assign(Object.assign({}, form), { name: event.target.value })));
                        } })),
                react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
                    react_1.default.createElement(TaskTypePicker_1.TaskTypePicker, { value: form.taskTypeId || undefined, textFieldProps: {
                            size: 'small',
                            label: 'Task Type',
                            placeholder: 'Select the Task Type'
                        }, onChange: taskType => {
                            setForm(form => {
                                return Object.assign(Object.assign({}, form), { taskTypeId: (taskType === null || taskType === void 0 ? void 0 : taskType.id) || null });
                            });
                        } })),
                existingWorkflow && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(StyledAlert, { severity: 'warning' },
                        react_1.default.createElement(lab_1.AlertTitle, null, "Task Type Conflict"),
                        react_1.default.createElement("div", null,
                            "A workflow with the same ",
                            react_1.default.createElement("strong", null, "Task Type"),
                            " already exists.",
                            react_1.default.createElement("br", null),
                            "(Existing Workflow Name:",
                            ' ',
                            react_1.default.createElement("strong", null, existingWorkflow.name),
                            ")"),
                        react_1.default.createElement("ul", null,
                            react_1.default.createElement("li", null,
                                "If you want to create a ",
                                react_1.default.createElement("strong", null, "Sub Task Workflow"),
                                ", please clear the ",
                                react_1.default.createElement("strong", null, "Task Type"),
                                " field as Sub Task Workflows do not require a Task Type."),
                            react_1.default.createElement("li", null,
                                "To replace the ",
                                react_1.default.createElement("strong", null, "Task Type"),
                                " from the existing Workflow, please confirm with the checkbox below."))),
                    react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
                        react_1.default.createElement(core_1.FormControlLabel, { className: 'content', label: react_1.default.createElement(core_1.Typography, { variant: 'body2' },
                                "Assign the selected ",
                                react_1.default.createElement("strong", null, "Task Type"),
                                " to this new Workflow"), control: react_1.default.createElement(core_1.Checkbox, { color: 'primary', disabled: isLoading, checked: form.replaceTaskType || false, onChange: () => {
                                    setForm(form => {
                                        return Object.assign(Object.assign({}, form), { replaceTaskType: !form.replaceTaskType });
                                    });
                                } }) })))),
                error && react_1.default.createElement(lab_1.Alert, { severity: 'error' }, error.message)),
            react_1.default.createElement(core_1.DialogActions, null,
                react_1.default.createElement(core_1.Button, { onClick: onCancel }, "Cancel"),
                react_1.default.createElement(core_1.Button, { type: 'submit', color: 'primary', variant: 'contained', disabled: !form.name || hasExisting, endIcon: isLoading && react_1.default.createElement(core_1.CircularProgress, { size: 20 }), onClick: e => {
                        e.preventDefault();
                        form.name && !hasExisting && createWorkflow(form);
                    } }, "Submit")))));
};
exports.CreateWorkflowDialog = CreateWorkflowDialog;
exports.default = exports.CreateWorkflowDialog;
//# sourceMappingURL=CreateWorkflowDialog.js.map